import axios from 'axios'
import store from '../store'
import router from '../router'

export default {      
    methods: {
        getCategories(){            
            //console.log('Inicio getCategories');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.categories = true;   
            var custNo = '';
            if (this.$store.state.usuario.type == 'Cliente')  {      
                custNo = this.$store.state.usuario.custNo;
            } else {
                custNo = this.$store.state.customer.no;
            } 
            var enableCustGroups = false;
            var appCustGroup = '';
            if (this.$store.state.usuario.type == 'Cliente')  {      
                enableCustGroups = this.$store.state.appconfig.enableCustGroups;
                appCustGroup = this.$store.state.usuario.appCustGroup;
            } 
            //this.axios.get(this.ApiBaseUrl + 'items/categorias/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID)    
            this.axios.post(this.ApiBaseUrlNETCore + 'categorias',{cust: custNo,enableCustGroups: enableCustGroups, appCustGroup: appCustGroup },{headers: {"Content-Type": "application/json"}})
            .then(response => {
                if (response.data == 'logout'){
                    this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                    store.commit("logout");
                }                                        
                /*for (var i = 0; i < response.data.length; i++){
                    response.data[i].allow = false;
                    response.data[i].active = false;
                }       */
                if (store.state.menuitems[0].items.length != response.data.length)
                    store.state.menuitems[0].items = response.data;
                else {
                    for (var i = 0; i < response.data.length; i++){                    
                        response.data[i].allow = store.state.menuitems[0].items[i].allow;
                        response.data[i].active = store.state.menuitems[0].items[i].active;
                        
                    }
                    store.state.menuitems[0].items = response.data;
                }
                if (store.state.appconfig.promociones){
                    store.state.promocionesGrupos = [];
                    for (var i = 0; i < store.state.menuitems[0].items.length; i++){   
                        if (store.state.menuitems[0].items[i].subCategories != null){
                            for (var j = 0; j < store.state.menuitems[0].items[i].subCategories.length; j++){   
                                if ((store.state.menuitems[0].items[i].subCategories[j].hasPromo) && !(store.state.menuitems[0].items[i].subCategories[j].hide)) {
                                    store.state.promocionesGrupos.push(store.state.menuitems[0].items[i].subCategories[j]);
                                }
                            }
                        }
                    }
                }
            })            
            .finally(function () {
                store.state.activeAxiosComms.categories = false;
                store.commit('hideGlobalLoader');                
            });
          },
          getRutas(){            
            //console.log('Inicio getRutas');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;   
                                                
            this.axios.post(this.ApiBaseUrlNETCore + 'rutas/list',{salesperson: this.$store.state.usuario.vendedor, completed: false},{headers: {"Content-Type": "application/json"}})
            .then(response => {
                if (response.data == 'logout'){
                    this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                    store.commit("logout");
                }                                        
                function getRandomColor() {
                    var letters = '0123456789ABCDEF';
                    var color = '#';
                    for (var i = 0; i < 6; i++) {
                        color += letters[Math.floor(Math.random() * 16)];
                    }
                    return color;
                }
                function hexToRgb(hex) {
                    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                    return result ? {
                      r: parseInt(result[1], 16),
                      g: parseInt(result[2], 16),
                      b: parseInt(result[3], 16)
                    } : null;
                  }
                var events = [];
                for (var i = 0; i < response.data.length; i++){
                    var color = getRandomColor();
                    var components = hexToRgb(color);
                    var textColor = "#fff";
                    if ((components.r*0.299 + components.g*0.587 + components.b*0.114) > 186) 
                        textColor =  "#000000";                    
                    var event = {
                        no: response.data[i].no,
                        title: response.data[i].decription,
                        details: response.data[i].decription,
                        date : response.data[i].date.substr(0,10),
                        customer: response.data[i].customerNo,  
                        customerName: response.data[i].customerAlias, 
                        startTime: response.data[i].startTimeStr,
                        endTime: response.data[i].endTimeStr,
                        style: "backgroundColor: " + color + ";border: 1px solid " + color + "; color: " + textColor,
                        backgroundColor: color,
                        textColor: textColor,
                        note: response.data[i].note,
                        potentialCustomer: response.data[i].potentialCustomer,
                        potentialCustomerName: response.data[i].potentialCustomerName,
                        open: false
                    }
                    events.push(event);
                }
                //store.state.rutasEventos = events;  
                store.commit('setRutas',events); 
            })            
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');                
            });
          },
          getRutasCompletadas(){            
            //console.log('Inicio getRutas');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;   
                                                
            this.axios.post(this.ApiBaseUrlNETCore + 'rutas/list',{salesperson: this.$store.state.usuario.vendedor, completed: true},{headers: {"Content-Type": "application/json"}})
            .then(response => {
                if (response.data == 'logout'){
                    this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                    store.commit("logout");
                }              
                var dateFrom = new Date(Date.parse(this.fechas[0].date));
                var dateTo = new Date(Date.parse(this.fechas[1].date));
                response.data.forEach( todo => {
                    var date_ = new Date(Date.parse(todo.date));
                    if ((date_ >= dateFrom) && (date_ <= dateTo) && ((todo.customerNo == this.$store.state.customer.no) || todo.potentialCustomer)){
                        var splitDate = date_.toLocaleDateString().split('/');
                        var invoice = {
                            numero: todo.no,
                            codCliente: todo.customerNo,
                            codClienteFact: todo.customerNo,
                            NombreClienteFact: todo.customerName,
                            NombreCliente: todo.customerName,
                            año: splitDate[2],
                            mes: splitDate[1],
                            dia: splitDate[0],
                            codProducto: todo.note,
                            descProducto: todo.decription,
                            cantidad: '',
                            importe: todo.startTimeStr + ' - ' + todo.endTimeStr,
                            importeTAX: todo.startTimeStr + ' - ' + todo.endTimeStr,
                            tipo: 'Tarea',
                            itemCategoryCode: '',
                            grupoCliente: todo.potentialCustomer,
                            grupoProducto: todo.potentialCustomerName
                        }
                        store.state.facturas.push(invoice);
                    }
                })
            })            
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');                
            });
          },
          getTodoComments(id){            
            //console.log('Inicio getRutas');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;   
                                                
            this.axios.post(this.ApiBaseUrlNETCore + 'rutas/getComments',{id: id},{headers: {"Content-Type": "application/json"}})
            .then(response => {                            
                if (response.data.length == 0) {
                    response.data = [{comment: '', id: 1}];
                }
                store.commit('setComentariosVisita',response.data);
            })            
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');                
            });
          },
          getTodoCommentsHist(id){            
            //console.log('Inicio getRutas');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;   
                                                
            this.axios.post(this.ApiBaseUrlNETCore + 'rutas/getComments',{id: id},{headers: {"Content-Type": "application/json"}})
            .then(response => {                            
                if (response.data.length == 0) {
                    response.data = [{comment: '', id: 1}];
                }
                console.log(response.data);
                store.commit('setComentariosVisitaHistorial',response.data);
            })            
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');                
            });
          },
        visitaSinPedido(id){
            console.log(id);
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;                                                   
            this.axios.post(this.ApiBaseUrlNETCore + 'Sales/closeTodo',{id: id, comentarios: this.$store.state.dialogCreateTodoData.comentarios},{headers: {"Content-Type": "application/json"}})
            .then(response => {        
                if (response.data){
                    this.getRutas();
                }
                store.commit('resetTaskData');
                router.push('rutas');
            })
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');
            });
        },
        cierraVisita(id,orderNo){
            console.log(id);
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;                                                   
            this.axios.post(this.ApiBaseUrlNETCore + 'Sales/closeTodoORder',{id: id, order: orderNo, comentarios: this.$store.state.dialogCreateTodoData.comentarios},{headers: {"Content-Type": "application/json"}})
            .then(response => {   
                store.commit('resetTaskData');     
            })
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');
            });
        },
        crearVisita(clientePotencial,nombreCP){
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;   
            /*this.$store.state.dialogCreateTodoData.info.date = 
                this.$store.state.dialogCreateTodoData.info.date.setTime(this.$store.state.dialogCreateTodoData.info.date.getTime() + 1 * 60 * 60 * 1000)*/
            var data = {};
            if (clientePotencial){
                data = {salesperson: this.$store.state.usuario.vendedor,
                    date: this.$store.state.dialogCreateTodoData.info.date,
                    customer: '',
                    nota: this.$store.state.dialogCreateTodoData.notaVisita,
                    start: this.$store.state.dialogCreateTodoData.start,
                    end: this.$store.state.dialogCreateTodoData.end,
                    cp: true,
                    nameCP: nombreCP,
                    comentarios: this.$store.state.dialogCreateTodoData.comentarios
                }
            } else {
                data = {salesperson: this.$store.state.usuario.vendedor,
                    date: this.$store.state.dialogCreateTodoData.info.date,
                    customer: this.$store.state.customer.no,
                    nota: this.$store.state.dialogCreateTodoData.notaVisita,
                    start: this.$store.state.dialogCreateTodoData.start,
                    end: this.$store.state.dialogCreateTodoData.end,
                    cp: false,
                    nameCP: '',
                    comentarios: this.$store.state.dialogCreateTodoData.comentarios
                }
            }
            this.axios.post(this.ApiBaseUrlNETCore + 'rutas/createTodo',
                data,
                {headers: {"Content-Type": "application/json"}}
            )
            .then(response => {        
                if (response.data){
                    this.getRutas();
                }
                store.commit('resetTaskData');
            })
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');
            });
        },
        actualizarVisita(clientePotencial,nombreCP){
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;   
            /*this.$store.state.dialogCreateTodoData.info.date = 
                this.$store.state.dialogCreateTodoData.info.date.setTime(this.$store.state.dialogCreateTodoData.info.date.getTime() + 1 * 60 * 60 * 1000)*/
            var data = {};
            if (clientePotencial){
                data = {salesperson: this.$store.state.usuario.vendedor,
                    date: new Date(Date.parse(this.$store.state.visitaDate) - (new Date()).getTimezoneOffset() * 60000),
                    customer: '',
                    nota: this.$store.state.dialogCreateTodoData.notaVisita,
                    start: this.$store.state.dialogCreateTodoData.start,
                    end: this.$store.state.dialogCreateTodoData.end,
                    cp: true,
                    nameCP: nombreCP,
                    no: this.$store.state.calEventDialogData.event.no,
                    comentarios: this.$store.state.dialogCreateTodoData.comentarios}
            } else {
                data = {salesperson: this.$store.state.usuario.vendedor,
                    date: new Date(Date.parse(this.$store.state.visitaDate) - (new Date()).getTimezoneOffset() * 60000),
                    customer: this.$store.state.customer.no,
                    nota: this.$store.state.dialogCreateTodoData.notaVisita,
                    start: this.$store.state.dialogCreateTodoData.start,
                    end: this.$store.state.dialogCreateTodoData.end,
                    cp: false,
                    nameCP: '',
                    no: this.$store.state.calEventDialogData.event.no,
                    comentarios: this.$store.state.dialogCreateTodoData.comentarios}
            }
            this.axios.post(this.ApiBaseUrlNETCore + 'rutas/updateTodo',
                data,
                {headers: {"Content-Type": "application/json"}}
            )
            .then(response => {        
                if (response.data){
                    this.getRutas();
                }
                store.commit('resetTaskData');
            })
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');
            });
        },
        comentariosVisita(id){
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;                                                   
            this.axios.post(this.ApiBaseUrlNETCore + 'Rutas/setTodoComments',{id: id, comentarios: this.$store.state.dialogCreateTodoData.comentarios},{headers: {"Content-Type": "application/json"}})
            .then(response => {   
                store.commit('resetTaskData');     
            })
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');
            });
        },
        getItems(){            
            this.checkSession();
            ////console.log('Inicio getItems');
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.items = true; 
            var filterVal = this.$store.state.filter;                       
            //if (filterVal == '') filterVal = '-1';
            var resCat = this.$store.state.menuitems[0].items.filter(cat=>{
                return cat.allow == true;
            });
            var thisaux = this;
            //Creacion de los filtros de categoria y subcategoria
            //var catFilter = '-1';
            //var subCatFilter = '-1';
            var catFilter = '';
            var subCatFilter = '';
            if (resCat.length){
                catFilter = '';
                for (var i = 0; i < resCat.length; i++){ 
                    if (catFilter != '') catFilter+='|';
                    catFilter += resCat[i].code;
					if (resCat[i].subCategories){
                        var resSubCat = resCat[i].subCategories.filter(subCat =>{return subCat.allow == true});
                        if (resSubCat.length){
                            subCatFilter = '';
                            for(var j = 0; j < resSubCat.length; j++){
                                if (subCatFilter != '') subCatFilter+='|';
                                subCatFilter += resSubCat[j].code;
                            }
                        }
                    }
                }
            }
            //console.log(this.$store.state.axiosSource);
            if (this.$store.state.axiosSource != undefined){
                this.$store.state.axiosSource.cancel('Petición obsoleta');
                //console.log('Peticion obsoleta');
            }            

            this.$store.state.axiosSource = this.axios.CancelToken.source(); 

            var locFilter = '';
            if (this.$store.state.tipoDocumento == 'disponible'){
                locFilter = this.$store.state.almacendisponible;                
                if (!locFilter) locFilter = this.$store.state.usuario.locationCode;
            } else {
                locFilter = this.$store.state.usuario.locationCode;
                if ((this.$store.state.usuario.type == 'Cliente') && (locFilter == '')){
                    locfilter = 'CEN';
                }
            }
            var url = '';
            var custNo = 'x';
            //simplificar esto
            if (!this.$store.state.topventas){
                if (this.$store.state.usuario.type == 'Cliente') { 
                    //url = this.ApiBaseUrl + 'items/' + this.$store.state.orderbygroup + '/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + catFilter + '/' + subCatFilter + '/' + filterVal + '/20/' + this.$store.state.usuario.custNo + '/' + this.$store.state.onlyAvailable + '/' + this.$store.state.onlyPromos + '/' + locFilter;
                    custNo = this.$store.state.usuario.custNo;
                } else {                    
                    //if (this.$store.state.selectedCustIndex > -1) custNo = this.$store.state.customer.no;
                    if (this.$store.state.customer != {}) custNo = this.$store.state.customer.no;
                    //url = this.ApiBaseUrl + 'items/' + this.$store.state.orderbygroup + '/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + catFilter + '/' + subCatFilter + '/' + filterVal + '/20/' + custNo + '/' + this.$store.state.onlyAvailable + '/' + this.$store.state.onlyPromos + '/' + locFilter;
                }
            } else{        
                if (this.$store.state.usuario.type == 'Cliente')  {      
                    //url =  this.ApiBaseUrl + 'items/top/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.usuario.custNo;
                    custNo = this.$store.state.usuario.custNo;
                } else {
                    //url =  this.ApiBaseUrl + 'items/top/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customer.no;
                    custNo = this.$store.state.customer.no;
                }
            }
            url = this.ApiBaseUrlNETCore + "items";
            if (custNo == '') {
                store.state.activeAxiosComms.items = false; 
                store.commit('hideGlobalLoader');
                return;
            }

            var enableCustGroups = false;
            var cpg = '';
            var cdg = '';
            var appCustGroup = '';
            if (this.$store.state.usuario.type == 'Cliente')  {      
                enableCustGroups = this.$store.state.appconfig.enableCustGroups;
                cpg = this.$store.state.usuario.salesGroup;
                cdg = this.$store.state.usuario.discGroup;
                appCustGroup = this.$store.state.usuario.appCustGroup;
            } else {
                cpg = this.$store.state.customer.customerPriceGroup;
                cdg = this.$store.state.customer.customerDiscGroup;
                appCustGroup = this.$store.state.customer.appCustGroup;
            }
                                    
            ////console.log(url);
            //this.axios.get(url,{cancelToken: this.$store.state.axiosSource.token})
            var epochSeconds = new Date();
            epochSeconds = parseInt(epochSeconds.getTime() / 1000);
            this.axios.post(url,
                {
                    filter: filterVal,
                    catfilter: catFilter,
                    subCatFilter: subCatFilter,
                    locfilter: locFilter,
                    manfilter: '',
                    disponible: this.$store.state.tipoDocumento == 'disponible' ? true : false,
                    top: this.$store.state.topventas,
                    user: this.$store.state.usuario.id,
                    userGUID: this.$store.state.usuario.userGUID,
                    cust: custNo,
                    orderByGrp: this.$store.state.orderbygroup,
                    onlyAvailable: this.$store.state.onlyAvailable,
                    onlyPromos: this.$store.state.onlyPromos,
                    limit: this.$store.state.appconfig.topItems,
                    enableCustGroups: enableCustGroups,
                    epochControl: epochSeconds,
                    appCustGroup: appCustGroup,
                    cpg: cpg,
                    cdg: cdg
                },{cancelToken: this.$store.state.axiosSource.token})
            .then(response => {    
                try{     
                    var epochControl = response.data.item2;
                    response.data = response.data.item1;
                    if ((response.data == 'logoutTime') || (response.data == 'logoutGUID')){
                        this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                        store.commit("logout");
                    }
                    //Control de peticiones por marca de tiempo.
                    //-----------------------------
                    if (epochControl < store.state.lastEpochControlItems){
                        store.state.activeAxiosComms.items = false; 
                        store.commit('hideGlobalLoader');
                        return;
                    } else 
                        store.commit("setEpochControlItems", epochControl);
                    //-----------------------------
                    if (response.data.length == undefined){
                        response.data = [response.data];
                    }                                       
                    /*if (this.$store.state.topventas){
                        var ordenados = [];
                        if (response.data.order != ''){
                            var orden = response.data.order.split('|');  
                            for (var i = 0; i < orden.length; i++){
                                var res = response.data.filter(itm =>{
                                    return itm.no == orden[i];
                                });
                                ordenados.push(res[0]);
                            }
                        }
                        response.data = ordenados;
                    }*/
                    var grupoTmp='x¬€¬x';          
                    for (var i = 0; i < response.data.length; i++){ 
                        if (response.data[i].picture != ''){
                            var urlParts = response.data[i].picture.split('/');
                            response.data[i].pictureN = '';
                            response.data[i].pictureL = '';
                            response.data[i].pictureXL = '';
                            for (var j = 0; j < urlParts.length; j++){
                                if (j==4){ // 3 = fotoscat
                                    if (j == urlParts.length-1){
                                        response.data[i].pictureN += 'Thumbnails/' + 'thumbnails_normal/' + urlParts[j];
                                        response.data[i].pictureL += 'Thumbnails/' + 'thumbnails_x-large/' + urlParts[j];
                                        response.data[i].pictureXL += 'Thumbnails/' + 'thumbnails_xx-large/' + urlParts[j];
                                    } else {
                                        response.data[i].pictureN += 'Thumbnails/' + urlParts[j] + '/';
                                        response.data[i].pictureL += 'Thumbnails/' + urlParts[j] + '/';
                                        response.data[i].pictureXL += 'Thumbnails/' + urlParts[j] + '/';
                                    }
                                    
                                } else if (j == urlParts.length-1) {
                                    response.data[i].pictureN += 'thumbnails_normal/' + urlParts[j];
                                    response.data[i].pictureL += 'thumbnails_x-large/' + urlParts[j];
                                    response.data[i].pictureXL += 'thumbnails_xx-large/' + urlParts[j];
                                } else {
                                    response.data[i].pictureN += urlParts[j] + '/';
                                    response.data[i].pictureL += urlParts[j] + '/';
                                    response.data[i].pictureXL += urlParts[j] + '/';
                                }
                            }
                        } else {
                            response.data[i].picture = require('../assets/noimage.png');
                            response.data[i].pictureN = require('../assets/noimage.png');
                            response.data[i].pictureL = require('../assets/noimage.png');
                            response.data[i].pictureXL = require('../assets/noimage.png');
                        }
                        
                        //response.data[i].picture = this.checkImg(response.data[i].picture);                                        
                        //var res = this.menuitems[0].items.filter(menuitem =>{return menuitem.Code == response.data[i].Category});
                        //response.data[i].visible = res[0].allow;
                        
                        /*if (response.data[i].prices.length == undefined){
                            response.data[i].prices = [response.data[i].prices];
                        }*/
                        var res = this.$store.state.orderItems.filter(itm=>{
                            return itm.no == response.data[i].no;
                        });
                        if (res.length){
                            response.data[i].cantidad = res[0].cantidad;
                        } else {
                            response.data[i].cantidad = 0;
                        }

                     
                                            
                        response.data[i].visible = true;
                        response.data[i].item = true;                    
                               
                        response.data[i].disponible = parseFloat(response.data[i].disponible).toFixed(2);
                        if (response.data[i].customerPrice != 0)
                            response.data[i].precio = response.data[i].customerPrice;
                        else if (response.data[i].customerPriceGroupPrice != 0)
                            response.data[i].precio = response.data[i].customerPriceGroupPrice;
                        else if (response.data[i].allCustomersPrice != 0)
                            response.data[i].precio = response.data[i].allCustomersPrice;
                        else
                            response.data[i].precio = 0;

                        if (Number(response.data[i].precio)){
                            response.data[i].precio = response.data[i].precio.toFixed(2);
                        }
                                                                                                                     
                        if (response.data[i].lotes){
                            for (var j = 0; j < response.data[i].lotes.length; j++){
                                response.data[i].lotes[j].disponible = parseFloat(response.data[i].lotes[j].disponible);
                            }
                        }
                        if (this.$store.state.tipoDocumento != 'abono'){
                            if (response.data[i].lotes){
                                if  (response.data[i].lotes.length){
                                    response.data[i].lotes = response.data[i].lotes.filter(lote =>{
                                        return lote.disponible > 0;
                                    })
                                }
                            }
                        }
                        response.data[i].uom = response.data[i].baseUOM;      
                        
                        if ((this.$store.state.orderbygroup) && (response.data[i].group != grupoTmp) && (!response.data[i].groupHeader)){
                            grupoTmp = response.data[i].Group;
                            var groupH = {
                                groupHeader: true,
                                groupName : (response.data[i].groupName != '') ? response.data[i].groupName : response.data[i].group,
                                groupCode : response.data[i].group
                            };                        
                            response.data.splice(i,0,groupH);                        
                            i++;
                        }
                        if ((response.data[i].itemTrackingCode == 'SEGLOTE') || (response.data[i].itemTrackingCode == 'SEGLOTECAD') || (response.data[i].itemTrackingCode == 'LOTNSVENT')){
                            response.data[i].trackingEnabled = true;
                        } else {
                            response.data[i].trackingEnabled = false;
                        }

                        if (response.data[i].promoCode == '0')
                            response.data[i].promoCode = null;
                    }                      
                    if ((response.data.length == 1) && (response.data[0].no == "")){
                        store.state.items = [];                        
                    } else           
                        store.state.items = response.data;   
                    if (store.state.appconfig.promociones){
                        store.state.promosDestacadas = [];
                        store.commit('setPromos',store.state.promosDestacadas);
                        thisaux.getPromos(store.state.items, epochControl);  
                    }                   
                    //thisaux.getUoms(store.state.items,0);
                    ////console.log(JSON.stringify(store.state.items));
                    store.state.activeAxiosComms.items = false; 
                    store.commit('hideGlobalLoader');
                    store.state.axiosSource = undefined; 
                } catch (e){
                    //console.log(e);
                    store.state.items = [];
                }
            })
            .catch(thrown => {
                if (axios.isCancel(thrown)) {
                  //console.log(thrown.message);
                } else {
                    store.state.activeAxiosComms.items = false; 
                    store.commit('hideGlobalLoader');
                    store.state.axiosSource = undefined; 
                    if (thrown.response){
                        if (thrown.response.data.includes('Exception: logoutGUID')){
                            store.state.dialogComercial = false;
                            this.setGlobalDialog('Sesión invalidada','Ha sido devuelto a la pagina de acceso',false);
                            store.commit("logout");
                        } else if (thrown.response.data.includes('Exception: logoutTime')){
                            store.state.dialogComercial = false;
                            this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                            store.commit("logout");
                        }
                    }
                }
            })
            .finally(function () {
                                               
            });
        },
        getPromos(items, epochControl){            
            var url = this.ApiBaseUrlNETCore + "promos";                                    
            //console.log(url);            
            var res = items.filter(item => {
                return (item.promoCode !=  null);
            });
            var ids = [];
            for(var i = 0; i<res.length; i++){
                ids.push(res[i].no);
            }
            if (ids.length > 0){            
                this.axios.post(url,{ids: ids})
                .then(response => {      
                    ////console.log(response);
                    //Control de peticiones por marca de tiempo.
                    //-----------------------------
                    if (epochControl < store.state.lastEpochControlItems)
                        return;
                    //-----------------------------
                    for(var i = 0; i<response.data.length; i++){
                        if (response.data[i].startingDate)
                            response.data[i].startingDateFormat = this.sqlDateToFormat(response.data[i].startingDate);
                        if (response.data[i].endingDate)
                            response.data[i].endingDateFormat = this.sqlDateToFormat(response.data[i].endingDate);
                        if (response.data[i].endingDateFormat == '01/01/1') 
                            response.data[i].endingDateFormat = '';
                        var resItems = items.filter(item => {
                            return (item.no == response.data[i].itemNo);
                        });
                        if (resItems[0].promos == null) resItems[0].promos = []
                        resItems[0].promos.push(response.data[i]);
                    }
                    store.commit('setItems',items);
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                         
                    //Se hace un resumen de las principales promociones en la seleccion de articulos actual
                    //La 3 primeras promocioes validas de 3 articulos
                    store.state.promosDestacadas = [];
                    store.commit('setPromos',store.state.promosDestacadas);
                    var res = items.filter(item => {
                        return (item.promos !=  null);
                    });            
                    for(var i = 0; i<res.length; i++){                
                        for (var j = 0; j < res[i].promos.length; j++){     
                            //if (res[i].promos[j].active){
                                if (res[i].promos[j].itemPromoPictureURL == ''){
                                    var file = require('../assets/noimage.png');
                                    res[i].promos[j].itemPromoPictureURL = file; 
                                }
                                store.state.promosDestacadas.push(res[i].promos[j]);
                                break;
                            //}
                        }                
                        if (store.state.promosDestacadas.length == 3) break;
                    }                                        
                    store.commit('setPromos',store.state.promosDestacadas);
                }); 
            }            
        },
        getPromosRedoOrder(items){            
            var url = this.ApiBaseUrlNETCore + "promos";                                    
            //console.log(url);  
            //Productos que no tienen que comprobar promociones
            var resDirect = items.filter(item => {
                return (item.promoCode ==  "0");
            });   
            for(var i = 0; i<resDirect.length; i++){
                this.setOrderItem(resDirect[i],true,false);
            }
            //Productos que tienen que comprobar promociones
            var res = items.filter(item => {
                return (item.promoCode !=  "0");
            });
            var ids = [];
            for(var i = 0; i<res.length; i++){
                ids.push(res[i].no);
            }
            if (ids.length > 0){    
                var thisaux = this;        
                this.axios.post(url,{ids: ids})
                .then(response => {      
                    ////console.log(response);
                    for(var i = 0; i<response.data.length; i++){
                        var resItems = items.filter(item => {
                            return (item.no == response.data[i].itemNo);
                        });
                        if (resItems[0].promos == null) resItems[0].promos = []
                        resItems[0].promos.push(response.data[i]);
                    }
                    thisaux.setOrderItem(resItems[0],true,false);
                    ///store.commit('setItems',items);
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                         
                    //return items;                                   
                }); 
            }            
        },
        getExpectedReceiptDate(item){    
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "items/getExpectedReceiptDate";                                    
            ////console.log(url);        
            this.axios.post(url,{no: item.no})
            .then(response => {      
                //console.log(response);
                if (response.data.length > 0){
                    var date_ = Date.parse(response.data);
                    var expectedDate = new Date(date_);
                    
                    this.setGlobalDialog('Sin diponibilidad','No hay existencias del producto ' + item.no + '. Fecha de recepción esperada: ' + expectedDate.toLocaleDateString(),false);
                }
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
            }); 
        },
        getUoms(item,openDialog,setOrder,forceinsert,forceupdate){    
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "uoms";     
            var custNo = '';
            if (this.$store.state.usuario.type == 'Cliente')  {      
                custNo = this.$store.state.usuario.custNo;
            } else {
                custNo = this.$store.state.customer.no;
            }                        
            if (custNo == undefined) custNo = '';
            ////console.log(url);        
            //if (i < items.length){
                //var item = items[i];
                this.axios.post(url,{id: item.no, cust: custNo})
                .then(response => {      
                    ////console.log(response);
                    item.uoms = response.data;
                    if ((response.data) && (response.data.length == 1)){
                        item.uom = response.data[0].code;
                    }
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                                                            
                    //store.commit('setItems',items);
                    //thisaux.getUoms(items,i+1);
                    if (openDialog){
                        thisaux.openDialog(item);
                    } else if (setOrder){
                        thisaux.setOrderItem(item,forceinsert,forceupdate);
                    }
                }); 
            //} 
        },
        getUomsAndCheckPrice(item,forceinsert,forceupdate){    
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "uoms";                                    
             var custNo = '';
            if (this.$store.state.usuario.type == 'Cliente')  {      
                custNo = this.$store.state.usuario.custNo;
            } else {
                custNo = this.$store.state.customer.no;
            }                        
            if (custNo == undefined) custNo = '';
            //console.log(url);        
            //if (i < items.length){
                //var item = items[i];
                this.axios.post(url,{id: item.no, cust: custNo})
                .then(response => {      
                    ////console.log(response);
                    item.uoms = response.data;
                    if ((response.data) && (response.data.length == 1)){
                        item.uom = response.data[0].code;
                    }
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                                                            
                    //store.commit('setItems',items);
                    //thisaux.getUoms(items,i+1);                    
                    thisaux.checkPriceAndCommitToCart(item,forceinsert,forceupdate);
                }); 
            //} 
        },
        getCustomers(returnToMenu){
            this.checkSession();
            var filter =  this.$store.state.custFilter;
            if (filter == ''){
                //filter = '-1';                
                return;
            }
            store.commit('showGlobalLoader');
            //this.$store.state.activeAxiosComms.customers = true;
            store.commit('setCustomerLoading',true);
            if (this.$store.state.axiosSourceCustomers != undefined){
                this.$store.state.axiosSourceCustomers.cancel('Petición obsoleta');
                //console.log('Peticion obsoleta');
            }            
            this.$store.state.axiosSourceCustomers = this.axios.CancelToken.source(); 
            var url = this.ApiBaseUrlNETCore + 'cust/search';
            this.axios
            .post(url, 
                {filter : filter, salesperson : this.$store.state.usuario.vendedor, user: this.$store.state.usuario.id, guid: this.$store.state.usuario.userGUID},
                {cancelToken: this.$store.state.axiosSourceCustomers.token,headers: {"Content-Type": "application/json"}}) //API
            .then(response => {       
                /*if (response.data.xml.cliente.length == undefined) 
                    response.data.xml.cliente = [response.data.xml.cliente];                  
                store.state.customers = response.data.xml.cliente;*/
                if (this.$store.state.customer && (this.$store.state.customer != {}) && (this.$store.state.customer != null))
                    response.data.push(this.$store.state.customer);
                store.state.customers = response.data;
                store.commit('setCustomerLoading',false);
                if (returnToMenu){
                    //this.getItems();
                    this.$router.push('menu');
                    
                }
            })
            .catch(function (error) {
                if (error.message != 'Peticion obsoleta')
                    store.commit('setCustomerLoading',false);

                // handle error
                //console.log(error);                 
              })
            .finally(function () {
                //store.state.activeAxiosComms.customers = false;
                store.state.axiosSourceCustomers = undefined; 
                store.commit('hideGlobalLoader');    
            });
        },
        getInvoices(selected){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.invoices = true;
            var fcd = '-1';
            var fch = '-1'; 
            var frd = '-1';
            var frh = '-1';
            if (this.$store.state.appconfig.filterInvoiceDocumentDate){
                fcd = this.formatDateBC(this.fechas[0].date);
                fch = this.formatDateBC(this.fechas[1].date);                
                frd = this.formatDateBC(this.fechas[2].date);
                frh = this.formatDateBC(this.fechas[3].date);                
            } else {
                frd = this.formatDateBC(this.fechas[0].date);
                frh = this.formatDateBC(this.fechas[1].date);                
            }
            var todos = true;
            if (selected && (selected.length > 0)){
                todos = false;
                for(var i = 0; i < selected.length; i++){
                    if (selected[i] == 'Tarea') todos = true;
                }
            }
            if (this.$store.state.usuario.type != 'Comercial')
                todos = false;
                            
        
            /*var url = this.ApiBaseUrl + '/pedidos/facturaspdtes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customer.no + '/' +
                      fcd + '/' + fch + '/' + frd + '/' + frh + '/nan/nan';
                      //console.log(url);*/
            var url = this.ApiBaseUrlNETCore + "Documents"; 
            var custNo;
            var userguid = '';
            if (this.$store.state.usuario.type == 'Comercial'){
                custNo = this.$store.state.customer.no;                
                userguid = this.$store.state.usuario.userGUID;
            } else {
                custNo = this.$store.state.usuario.custNo;
                userguid = this.$store.state.usuario.userGUID;
            }
            if (selected == undefined) selected = ["all"];

            this.axios.post(url,{filtroCliente: custNo,
                fechaCreaDesde : fcd,
                fechaCreaHasta : fch,
                fechaRegistroDesde : frd,
                fechaRegistroHasta : frh,
                cabeceras : true,
                filtroDocumento : "",
                filtroTipoDocumento : selected,
                user: this.$store.state.usuario.id,
                guid: userguid})
            //this.axios.get(url)
            .then(response => {
                if (response.data.length == undefined)
                    response.data = [response.data]                    
                store.state.facturas = response.data;
                for (var i = 0; i < store.state.facturas.length; i++){
                    store.state.facturas[i].selected = false;
                    store.state.facturas[i].mail = false;
                    if (store.state.facturas[i].numero == ''){                        
                        store.state.facturas.splice(i,1);
                    }
                }
                if (store.state.facturas.length == 0) store.state.facturas = [];
                if (todos){
                    this.getRutasCompletadas()
                }
                //console.log(store.state.facturas);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.invoices = false; 
                store.commit('hideGlobalLoader');             
            });

        },
        getInvoice(docNo){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.invoices = true;
            var fcd = '-1';
            var fch = '-1'; 
            var frd = '-1';
            var frh = '-1';                                                
            /*var url = this.ApiBaseUrl + '/pedidos/facturaspdtes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customer.no + '/' +
                      fcd + '/' + fch + '/' + frd + '/' + frh + '/nan/nan';
                      //console.log(url);*/
            var url = this.ApiBaseUrlNETCore + "Documents";   
            var custNo;
            var userguid = '';
            if (this.$store.state.usuario.type == 'Comercial'){
                custNo = this.$store.state.customer.no                
                userguid = this.$store.state.usuario.userGUID;
            } else {
                custNo = this.$store.state.usuario.custNo;  
                userguid = this.$store.state.usuario.userGUID;
            }                   
            this.axios.post(url,{filtroCliente: custNo,
                fechaCreaDesde : fcd,
                fechaCreaHasta : fch,
                fechaRegistroDesde : frd,
                fechaRegistroHasta : frh,
                cabeceras : false,
                filtroDocumento : docNo,
                filtroTipoDocumento : [],
                user: this.$store.state.usuario.id,
                guid: userguid})
            //this.axios.get(url)
            .then(response => {
                if (response.data.length == undefined)
                    response.data = [response.data]                    
                store.state.facturaActual = response.data;
                for (var i = 0; i < store.state.facturaActual.length; i++){                    
                    if (store.state.facturaActual[i].numero == ''){                        
                        store.state.facturaActual.splice(i,1);
                    }
                }
                if (store.state.facturaActual.length == 0) store.state.facturaActual = [];
                //console.log(store.state.facturaActual);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.invoices = false; 
                store.commit('hideGlobalLoader');             
            });

        },
        sendDocument(docNo,docType,email,year){
            var docTypeMsg = docType;
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.invoices = true;            
            var url = this.ApiBaseUrlNETCore + "MailingDocuments";   
            switch(docType){
                case 'PEDIDO':
                    docType = 0;
                    break;
                case 'Factura':
                    docType = 1;
                    break;
                case 'Factura Alb.':
                    docType = 2;
                    break;
                case 'Abono':
                    docType = 3;
                    break;
                case '347':
                    docType = 4;
                    if (this.$store.state.usuario.type == 'Cliente'){
                        docNo = this.$store.state.usuario.userGUID;
                    }
                    break;
            }
            this.axios.post(url,{docNo: docNo,
                docType : docType,
                email : email,
                year : year
            })
            //this.axios.get(url)
            .then(response => {
                //console.log(response);
                this.setGlobalDialog('Envío de ' + docTypeMsg,response.data,false);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.invoices = false; 
                store.commit('hideGlobalLoader');             
            });

        },
        anulaFactura(){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.anularFactura = true;
            var url = '';
            this.axios.get(url)
            .then(response => {               
                //console.log(response);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.anularFactura = false; 
                store.commit('hideGlobalLoader');             
            });
        },
        cobraFactura(documentNo){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.cobrarFactura = true;
            //var url = this.ApiBaseUrl + '/pedidos/lineacobro/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.tipoCobro + '/' + documentNo + '/' + this.$store.state.numCheque;
            //this.axios.get(url)
            var url = this.ApiBaseUrlNETCore + "documents/lineacobro/";
            this.axios
            .post(url, {user: this.$store.state.usuario.id, guid: this.$store.state.usuario.userGUID, tipo: this.$store.state.tipoCobro, factura: documentNo, cheque: this.$store.state.numCheque },{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {                
                //console.log(response);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.cobrarFactura = false; 
                store.commit('hideGlobalLoader');         
                this.getInvoices();    
            });
        },
        sendOrderMail(docNo){        
            //var url = this.ApiBaseUrl + "pedidos/notificacion/-1/-1/" + docNo;
            var url = this.ApiBaseUrlNETCore + "documents/notificacion";
            this.axios.post(url, {docno : docNo },{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {      
                ////console.log(response);
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
            }); 
            
        },
        downloadDocument(doc){
            var url = this.ApiBaseUrlNETCore + "documents/descargaDocumento";
            this.axios.post(url, {type: doc.tipo, docno : doc.numero },{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {   
                const base64 = response.data.replace(/\s/g, '');
                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
                }   
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                window.open(url, '_blank');
                //window.open("data:application/pdf;base64," + response.data, '_blank');
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
            }); 
        },
        saveOrder(showMessage){
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "items/saveOrder";
            //console.log(url);        
            this.axios.post(url,{orderJson: JSON.stringify(this.$store.state.orderItems), user: this.$store.state.usuario.id})
            .then(response => {      
                ////console.log(response);
                if (response.status == 200){
                    if (showMessage) thisaux.setGlobalDialog('Pedido guardado','Pedido guardado en el sistema',false);
                }
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
                store.commit('hideGlobalLoader'); 
                //store.commit('resetOrderItems'); 
                store.commit('cancelLoading');   
            }); 
        },
        getStoredOrder(){
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "items/getStoredOrder";
            //console.log(url);        
            this.axios.post(url,{uguid: this.$store.state.usuario.userGUID})
            .then(response => {      
                if (response.data.length){
                    //var lines = JSON.parse(response.data[0]);
                    store.commit('resetOrderItems');
                    response.data.forEach( line => {
                        thisaux.checkPriceAndCommitToCart(line,false,false);
                    });
                    //store.state.orderItems = response.data;
                } else {
                    thisaux.setGlobalDialog('Pedido vacío','No existe pedido',false);
                }
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
                store.commit('hideGlobalLoader'); 
                //store.commit('resetOrderItems'); 
                store.commit('cancelLoading');   
            }); 
        },
        clearStoredOrder(){
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "items/saveOrder";
            //console.log(url);        
            this.axios.post(url,{orderJson: '', user: this.$store.state.usuario.id})
            .then(response => {      
                ////console.log(response);
                
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
                store.commit('hideGlobalLoader'); 
                store.commit('resetOrderItems'); 
                store.commit('resetTaskData');
                store.commit('cancelLoading');   
            }); 
        },
        createOrder(cobrar,total){          
            /*if ((this.$store.state.usuario.id == 'alio') || (this.$store.state.usuario.id == 'alio2')){
                store.commit('setOrderItems',store.state.orderItems);
                store.commit('flipLoading'); 
                this.setPaymentDialog('Pedido creado','Se ha creado el pedido nº xxx en el sistema. ¿Desea pagarlo con tarjeta?','PVXXX',total);
                return;
            }*/
            try{
                //console.log('Inicio createOrder');  
                store.commit('showGlobalLoader');
                this.$store.state.activeAxiosComms.order = true; 
                var now = new Date();
                var fechaRegistro = '';
                var abono =  0;
                if (this.$store.state.tipoDocumento == 'abono')
                    abono = 1;
                if ((now.getMonth() + 1) < 10) fechaRegistro += '0' + (now.getMonth() + 1);
                else fechaRegistro += now.getMonth() + 1;
                if ((now.getDate()) < 10) fechaRegistro += '0' + now.getDate();
                else fechaRegistro += now.getDate();
                fechaRegistro+= now.getFullYear();
                
                var salesperson = '';
                if (this.$store.state.usuario.type == 'Comercial'){
                    salesperson = this.$store.state.usuario.vendedor;
                    this.saveOrder(false);
                }
                var url = '';
                if (abono) url = this.ApiBaseUrlNETCore + 'Sales/CreateSalesCreditMemo';
                else url = this.ApiBaseUrlNETCore + 'Sales/CreateSalesOrder';
                var salesHeader = { 
                    OrderNo: "",
                    CustNo: "",
                    user: "",
                    abono: false,
                    idEvento: '',
                    nota: this.$store.state.notaPedido,
                    notaRepartidor: this.$store.state.notaRepartidor,
                    salesperson : salesperson,
                    postingDate: now,
                    SalesLines: [],
                    userType: this.$store.state.usuario.type,
                    editPrices: this.$store.state.usuario.editPrices,
                    nota: '',
                    notaRepartidor: '',
                    shipToAddress: ''
                };
                salesHeader.user = this.$store.state.usuario.id;
                salesHeader.abono = abono;
                salesHeader.idEvento = this.$store.state.idEvento;
                var salesLines = [];
                for (var i = 0; i < this.$store.state.orderItems.length; i++){
                    if (!this.$store.state.orderItems[i].isPromo) {
                        var line = {
                            itemno: '',
                            qty: 0,
                            location: '',
                            uom: '',
                            price: 0,
                            dto: 0
                        }
                        var lote = null;
                        var expDate = new Date();
                        if ((this.$store.state.tipoDocumento == 'abono') && (this.$store.state.orderItems[i].lotes)){
                            lote = this.$store.state.orderItems[i].lote;
                            lote.forEach(lot => {
                                var loteInfo = this.$store.state.orderItems[i].lotes.find(itm =>{
                                    return itm.lote == lot.lote;
                                });
                                if (loteInfo){
                                    lot.expDate = loteInfo.caducidad;
                                } else {
                                    lot.expDate = expDate;
                                }
                            });
                        }
                        line.itemno = this.$store.state.orderItems[i].no;
                        line.qty = this.$store.state.orderItems[i].cantidad;
                        line.uom = this.$store.state.orderItems[i].uom;
                        line.price = this.$store.state.orderItems[i].precio;
                        line.dto = this.$store.state.orderItems[i].descuento;
                        line.lote = lote;     
                        //Fix para que entre en nav el 0
                        if ((line.dto == 0) || (line.dto == '0')) line.dto = '0.0';               

                        salesLines.push(line);
                    }
                }
                salesHeader.SalesLines = salesLines;
                if (this.$store.state.usuario.type == 'Cliente'){
                    salesHeader.CustNo = this.$store.state.usuario.custNo;
                } else {
                    salesHeader.CustNo = this.$store.state.customer.no;
                }
                var thisAux = this;
                this.axios.post(url,salesHeader)
                .then(response => {
                    if ((response.status == 200) || (response.status == 201)){
                        if (thisAux.$store.state.idEvento != ''){
                            thisAux.comentariosVisita(thisAux.$store.state.idEvento);
                        }
                        if ((store.state.appconfig.autoventa) && (store.state.tipoDocumento == 'autoventa')){
                            thisAux.autoventapost(response.data,cobrar,false);
                            store.commit('resetOrderItems');
                            store.commit('cancelLoading');
                        } else if (store.state.tipoDocumento == 'abono'){
                            thisAux.autoventapost(response.data,cobrar,true);
                            store.commit('resetOrderItems');
                            store.commit('cancelLoading'); 
                        } else if ((store.state.appconfig.redsysEnable) && (store.state.usuario.type == 'Cliente') /*&& (store.state.usuario.id == 'alio')*/){
                            store.commit('resetOrderItems');
                            store.commit('cancelLoading'); 
                            //this.setPaymentDialog('Pedido creado','Se ha creado el pedido nº xxx en el sistema. ¿Desea pagarlo con tarjeta?','PVXXX',total);
                            if (store.state.usuario.type == 'Cliente'){
                                thisAux.clearStoredOrder();
                            }
                            thisAux.setPaymentDialog(thisAux.getDocTitle() + ' creado','Se ha creado el ' + thisAux.getDocTitle().toLowerCase()  + ' nº ' + response.data + ' en el sistema',response.data,total);
                            
                        } else {       
                            store.commit('hideGlobalLoader'); 
                            store.commit('resetOrderItems'); 
                            store.commit('cancelLoading');                                 
                            store.state.tipoDocumento = '';
                            //this.navigate(1);
                            if (store.state.usuario.type == 'Cliente'){
                                thisAux.clearStoredOrder();
                            }
                            //Creado con incidencias. Esta respuesta solo viene de la api cuando crea el pedido pero falla al crear la nota o al cerrar la tarea
                            if ((store.state.usuario.type == 'Comercial') && (response.status == 201))
                                thisAux.setGlobalDialog(thisAux.getDocTitle() + ' creado, con incidencias','Se ha creado el ' + thisAux.getDocTitle().toLowerCase()  + ' nº ' + response.data + ' en el sistema pero con incidencias. Revise la tarea o la nota asociadas',true);
                            else
                                thisAux.setGlobalDialog(thisAux.getDocTitle() + ' creado','Se ha creado el ' + thisAux.getDocTitle().toLowerCase()  + ' nº ' + response.data + ' en el sistema',true);
                        }
                    } else {
                        thisAux.setGlobalDialog('Error', response.data,false);
                    }
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);
                    thisAux.setGlobalDialog('Error',error.message,false);
                    store.commit('cancelLoading');
                })
                .finally(function () {   
                    store.state.activeAxiosComms.order = false; 
                    store.commit('hideGlobalLoader');             
                });
            } catch (e){
                this.setGlobalDialog('Error',error.message,false);
                store.commit('cancelLoading');
                store.commit('hideGlobalLoader');  
            }
        },
        GetAvailable(itemno){
            var thisaux = this;
            this.$store.commit("setAvailable",[]);
            //itemno = JSON.stringify(itemno);
            this.axios.post(this.ApiBaseUrlNETCore + 'items/ItemAvail',{ itemno },{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                //this.Available = JSON.parse(response.data.body.res)
                
                //var avail = JSON.parse(response.data.res);
                var avail = response.data;
                avail.forEach(av => {
                    av.QtyAvailable = parseFloat(av.QtyAvailable);
                    av.PurchLinesQty = parseFloat(av.PurchLinesQty);
                    if (!Number(av.PurchLinesQty)) av.PurchLinesQty = 0;
                    //av.QtyAvailable = av.QtyAvailable - av.PurchLinesQty;
                });
                avail = avail.filter(av => {
                    return (av.QtyAvailable != 0) || (av.PurchLinesQty != 0);
                }); 
                //console.log(avail);
                thisaux.$store.commit("setAvailable",avail);
            })
        },
        autoventapost(orderNo,cobrar,abono){
            var factAuto = (this.$store.state.customer.combineShipments == 'No') ? false : true;
            if (factAuto){
                cobrar = false;
            }
            this.$store.state.activeAxiosComms.posting = true;
            var url = '';
            /*if (abono)
                //url = this.ApiBaseUrl + 'pedidos/registro/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + orderNo + '/1';
            else
                //url = this.ApiBaseUrl + 'pedidos/registro/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + orderNo + '/0';
            this.axios.get(url)*/
            var url = this.ApiBaseUrlNETCore + "documents/registro/";
            this.axios.post(url, {user : this.$store.state.usuario.id, guid : this.$store.state.usuario.userGUID, order: orderNo, abono: abono},{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {
                var capitalDocStr = '';
                var docStr = '';
                var postedDocStr  = '';
                var docType = '';
                if ((!abono) && (!factAuto)) {
                    docStr = 'pedido';
                    postedDocStr = 'factura';
                    docType = 'FRA';
                    capitalDocStr = 'Pedido';
                } else if ((!abono) && (factAuto)){
                    docStr = 'pedido';
                    postedDocStr = 'albarán';
                    docType = 'ALB';
                    capitalDocStr = 'Pedido';
                } else if ((abono) && (!factAuto)){
                    docStr = 'abono';
                    postedDocStr = 'abono registrado';
                    docType = 'ABO';
                    capitalDocStr = 'Abono';
                } else if ((abono) && (factAuto)){
                    docStr = 'abono';
                    postedDocStr = 'recepción';
                    docType = 'RCP';
                    capitalDocStr = 'Abono';
                }                
                store.state.tipoDocumento = '';
                //this.navigate(1);
                if ((response.data == 'Nada que registrar') || (response.data == undefined))
                    this.setGlobalDialog('Error al registrar','Se ha creado el ' + docStr + ' nº ' + orderNo + ' en el sistema pero no ha sido posible registrarlo. Contacte con administración',true);
                else{
                    this.setGlobalDialogPrint(capitalDocStr + ' creado','Se ha creado el ' + docStr + ' nº ' + orderNo + ' en el sistema, ' + postedDocStr + ' nº ' + response.data,true,response.data,docType);
                    if (cobrar) this.lanzaDialogCobro(response.data);
                }
            })
            .catch(function (error) {
                // handle error
                //console.log(error);
                store.commit('hideGlobalLoader');    
              })
            .finally(function () {
                store.state.activeAxiosComms.posting = false;
            });
        },
        checkPriceAndCommitToCart(item,forceinsert,forceupdate){
            var auxstore = this.$store;
            var thisaux = this;
            var url = '';
            var price = 0;
            if (item.precioEditado)
                price = item.precio;            
            if (item.descuento == undefined)
                item.descuento = 0;

            if (item.uoms == null){
                this.getUomsAndCheckPrice(item,forceinsert,forceupdate);            
            } else { 
                url = this.ApiBaseUrlNETCore + "documents/detalleLinea/";
                var req = {};
                if (this.$store.state.usuario.type == 'Cliente')  
                    //url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.usuario.custNo + '/' + item.no + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
                    req = { user:  this.$store.state.usuario.id,
                        guid: this.$store.state.usuario.userGUID,
                        custNo: this.$store.state.usuario.custNo,
                        itemNo: item.no,
                        uom: item.uom,
                        Qty: item.cantidad,
                        unitprice: price,
                        linedisc: item.descuento
                    }
                else
                    //url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customer.no + '/' + item.no + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
                    req = { user:  this.$store.state.usuario.id,
                        guid: this.$store.state.usuario.userGUID,
                        custNo: this.$store.state.customer.no,
                        itemNo: item.no,
                        uom: item.uom,
                        Qty: item.cantidad,
                        unitprice: price,
                        linedisc: item.descuento
                    }
                this.axios.post(url, req,{headers: {"Content-Type": "application/json"}}) //API
                //this.axios.get(url)
                .then(response => {
                    //console.log(response);
                    if (response.status == 200){
                        item.precio = parseFloat(response.data.unitprice.replace(',',''));
                        item.descuento = parseFloat(response.data.linedisc);
                    }
                    //this.$store.commit('setOrderItem', item);                                   
                })
                .catch(function (error) {                
                    // handle error
                    //console.log(error);
                })
                .finally(function () {   
                    thisaux.setOrderItem(item, forceinsert,forceupdate);                                           
                });
            }
        },
        commitToCart(item,forceinsert,forceupdate){
            this.$validator.validate().then(valid => {
                if (!valid) {
                    ok = false;
                } else {
                    //Copiamos el objeto para no alterar sus datos aparte de la cantidad
                    var commitItem =  Object.assign({}, item);
                    if ((commitItem.disponible <= 0) /*&& (this.$store.state.usuario.type == 'Comercial')*/){
                        this.getExpectedReceiptDate(item); 
                    }
                    /*if (this.$store.state.usuario.type == 'Cliente'){
                        if (commitItem.disponible <= 0){
                            this.setGlobalDialog('Sin diponibilidad','No hay existencias del producto ' + commitItem.no,false);
                            this.getExpectedReceiptDate(item);
                            this.getItems();
                            return;
                        }
                    }*/
                    if (this.$store.state.tipoDocumento == 'autoventa'){
                        if (commitItem.disponible <= 0){
                            this.setGlobalDialog('Sin diponibilidad','No hay existencias del producto ' + commitItem.no,false);
                            this.getItems();
                            return;
                        }
                        if ((commitItem.disponible - commitItem.cantidad) <= 0){
                            this.setGlobalDialog('Exceso de cantidad','Se ha introducido mayor cantidad (' + commitItem.cantidad + ') que la disponible para el producto ' + commitItem.no + ' (' + commitItem.disponible + ')',false);
                            this.getItems();
                            return;
                        }                
                    }
                    if ((commitItem.precio == 0) && (commitItem.descuento != 100)){
                        this.setGlobalDialog('Linea sin precio','No se ha introducido precio para el producto ' + commitItem.no ,false);
                        this.getItems();
                        return;
                    }
                    /*if ((this.$store.state.appconfig.promociones) && (item.promos != undefined)){
                        var del = false;
                        for (var i = 0; i < this.$store.state.orderItems.length;){
                            if (this.$store.state.orderItems[i].isPromo && (this.$store.state.orderItems[i].fromitemNo == item.no)){
                                this.$store.state.orderItems.splice(i, 1);
                                del = true;
                            } else {
                                i++;
                            }
                        }
                        if (del) this.$store.commit('setOrderItems', this.$store.state.orderItems);
                    }*/
                    this.checkPriceAndCommitToCart(commitItem,forceinsert,forceupdate); 
                }           
            })
        },
        generateHash (string){
            let hash = 0;
            for (const char of string) {
                hash = (hash << 5) - hash + char.charCodeAt(0);
                hash |= 0; // Constrain to 32bit integer
            }
            return hash;
        },
        getAppConfig(){
            //console.log('Inicio getAppConfig');
            /*this.axios.get(this.ApiBaseUrl + 'appconfig')
            .then(response => {          
                this.$store.state.appconfig.appname1 = response.data.xml.config.name;
                this.$store.state.appconfig.appname2 = response.data.xml.config.name2;
                this.$store.state.appconfig.defaultOrderType = response.data.xml.config.defaultOrderType.toLowerCase();                            
                if (response.data.xml.config.showLineCategories != 'No')
                  this.$store.state.appconfig.showLineCategories = true;
                else
                  this.$store.state.appconfig.showLineCategories = false;

                if (response.data.xml.config.autoventa != 'No')
                  this.$store.state.appconfig.autoventa = true;
                else
                  this.$store.state.appconfig.autoventa = false;

                if (response.data.xml.config.showAppSufix != 'No')            
                  this.$store.state.appconfig.showAppSufix = true;
                else
                  this.$store.state.appconfig.showAppSufix = false;

                if (response.data.xml.config.showItemPhoto != 'No')            
                  this.$store.state.appconfig.showItemPhoto = true;
                else
                  this.$store.state.appconfig.showItemPhoto = false;
                
                if (response.data.xml.config.filterInvoiceDocumentDate != 'No')            
                  this.$store.state.appconfig.filterInvoiceDocumentDate = true;
                else
                  this.$store.state.appconfig.filterInvoiceDocumentDate = false;

                if (response.data.xml.config.allowUOMS != 'No')            
                  this.$store.state.appconfig.allowUOMS = true;
                else
                  this.$store.state.appconfig.allowUOMS = false;

                if (response.data.xml.config.showVAT != 'No')            
                  this.$store.state.appconfig.showVAT = true;
                else
                  this.$store.state.appconfig.showVAT = false;

                if (response.data.xml.config.promociones != 'No')            
                  this.$store.state.appconfig.promociones = true;
                else
                  this.$store.state.appconfig.promociones = false;

                if (response.data.xml.config.enableCustGroups != 'No')            
                  this.$store.state.appconfig.enableCustGroups = true;
                else
                  this.$store.state.appconfig.enableCustGroups = false;  
                if (response.data.xml.config.redsysEnable != 'No')            
                  this.$store.state.appconfig.redsysEnable = true;
                else
                  this.$store.state.appconfig.redsysEnable = false;                 
                this.$store.state.appconfig.version = response.data.xml.config.version;
                this.$store.state.appconfig.revision = response.data.xml.config.revision;
                this.$store.state.appconfig.servicesLanguage = response.data.xml.config.servicesLanguage;   
                if (response.data.xml.config.topItems != 0){
                    this.$store.state.appconfig.topItems = response.data.xml.config.topItems;
                }
            })
            */
           var url = this.ApiBaseUrlNETCore + "config/getConfig";
           this.axios
           .post(url,{},{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {
                var config = response.data;
                switch(config.defaultOrderType){
                    case 0:
                        config.defaultOrderType = '';
                        break;
                    case 1:
                        config.defaultOrderType = 'preventa';
                        break;
                    case 2:
                        config.defaultOrderType = 'autoventa';
                        break;
                    case 3:
                        config.defaultOrderType = 'abono';
                        break;
                }
                switch(config.NAVversion){
                    case 0:
                        config.NAVversion = 2013;
                        break;
                    case 1:
                        config.NAVversion = 2015;
                        break;
                    case 2:
                        config.NAVversion = 2017;
                        break;
                    case 3:
                        config.NAVversion = 2018;
                        break;
                    case 4:
                        config.NAVversion = 2019;
                        break;
                }
                switch(config.NAVrevision){
                    case 0:
                        config.NAVrevision = '';
                        break;
                    case 1:
                        config.NAVrevision = 'R2';
                        break;
                }
                switch(config.servicesLanguage){
                    case 0:
                        config.servicesLanguage = '';
                        break;
                    case 1:
                        config.servicesLanguage = 'es';
                        break;
                    case 2:
                        config.servicesLanguage = 'en';
                        break;
                }
                config.defaultOrderType = config.defaultOrderType.toLowerCase();
                this.$store.state.appconfig = config;
                if ((config.adAppTitle != '') || (config.adAppBody != '') || (config.adAppURL != '')){
                    var ad = {
                        titulo: config.adAppTitle != '' ? config.adAppTitle : '',
                        contenido: config.adAppBody != '' ? config.adAppBody : '',
                        imagen:config.adAppURL != '' ? config.adAppURL : '',
                    }
                    var hash = this.generateHash(JSON.stringify(ad));
                    if (this.$store.state.adDialogData.hash != hash){
                        this.$store.state.adDialogData.titulo = ad.titulo;
                        this.$store.state.adDialogData.contenido = ad.contenido;
                        this.$store.state.adDialogData.imagen = ad.imagen;
                        this.$store.state.adDialogData.visto = ad.false;
                        this.$store.state.adDialogData.hash = hash;
                        this.$store.commit('setAdDialogData', this.$store.state.adDialogData)
                    }
                    if (this.$store.state.usuarioLogeado && !this.$store.state.adDialogData.visto){
                        this.$store.commit('setAdDialog',true);
                    }
                }
                //if (config.version != this.$store.state.appversion) window.location.reload(true);
                //console.log(response);
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
              })
            .finally(function () {                
            });
        },
        checkVersion(){
           var url = this.ApiBaseUrlNETCore + "config/getConfig";
           var thisaux = this;
           this.axios
           .post(url,{},{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {
                var config = response.data[0];
                if (config.version != store.state.appversion) {
                    var retries = thisaux.$store.state.updateRetries;
                    if (retries >= 2){
                        if (thisaux.$route.name != 'updateFail'){
                            thisaux.$store.commit("logoutInternal");
                            thisaux.$router.push('updateFail');
                        } 
                        return;
                    } else {
                        retries += 1;
                        thisaux.$store.commit("setUpdateRetries",retries);
                        window.location.reload(true);
                        return;
                    }
                }
                store.commit("setUpdateRetries",0);
                if (thisaux.$route.name == 'updateFail'){
                    thisaux.$router.push('/');  
                }
                //console.log('check version ok');
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
              })
            .finally(function () {                
            });
        },
        checkSession(){
            if (this.$store.state.usuarioLogeado){
                var url = this.ApiBaseUrlNETCore + "login/checkSession/";
                this.axios.post(url, {user : this.$store.state.usuario.id , guid : this.$store.state.usuario.userGUID },{headers: {"Content-Type": "application/json"}}) //API
                //this.axios.get(this.ApiBaseUrl + 'checkUserGUID/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID)
                .then(response => {          
                    ////console.log(response);   
                    if (!response.data){
                        this.$store.state.dialogPayment = false;
                        this.$store.state.dialogComercial = false;

                        this.setGlobalDialog('Sesión de usuario invalidada','Ha sido devuelto a la pagina de acceso, acceda de nuevo',false);
                        store.commit("logout");
                    }
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                
                })
                .finally(function () {                
                });
            }
        },
        getLiqReport(){
            //console.log('Inicio getLiqReport');
            var url = this.ApiBaseUrlNETCore + "documents/informeliquidacioncomerciales/";
            this.axios.post(url, {user : this.$store.state.usuario.id, type : this.$store.state.tipoInforme },{headers: {"Content-Type": "application/json"}}) //API
            ///this.axios.get(this.ApiBaseUrl + 'informeliquidacioncomerciales/' + this.$store.state.usuario.id + '/' + this.$store.state.tipoInforme + '/')
            .then(response => {                          
                  //console.log(response);
                  //console.log(window.location.pathname);                  
                  window.open(this.PrintDocsFolder + response.data); 
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
              })
            .finally(function () {                
            });
        },
        checkImg(url){
            this.axios.get(url)
            .then(response => {     
                return url;
            })
            .catch(error => {                
                return '';
            });            
        },
        getSalesPrice(item){
            
        },
        setOrderItem(item,forceinsert,forceupdate){         
            //console.log(store.state.orderItems);       
            item.qtyperuom = 1;
                        
            if (item.uoms == null){
                this.getUoms(item,false,true,forceinsert,forceupdate);            
            } else {   
                //Excepcion para la funcion de repetir ultimo pedido, para los casos
                //en los que se ha vendido el producto en una unidad de medida que ya no 
                //esta disponible/visible en la app
                if ((item.uom_NAV != undefined) && (item.uom_NAV != undefined) && (item.uom_NAV != item.uom)){
                    //console.log("Producto " + item.no + " " + item.description + " no disponible en formato:" + item.uom_NAV);
                    return;
                }
                var res = item.uoms.filter(uom => {
                    return uom.code == item.uom;
                });
                if (res.length){
                    item.qtyperuom = parseFloat(res[0].qty_per_uom);
                }
                if (item.qtyperuom == NaN) item.qtyperuom = 1;

                if (item.isPromo == undefined) item.isPromo = false; 
                var res = [];                    
                if (forceupdate){
                    res = store.state.orderItems.filter(itm=>{
                        return (itm.no == item.no);
                    });
                } else {
                    res = store.state.orderItems.filter(itm=>{
                        return (itm.no == item.no) && (itm.lote == item.lote) && (itm.precio == item.precio) && (itm.descuento == item.descuento);
                    });
                }
                if (res.length && !forceinsert){
                    if (item.cantidad != 0){
                    res[0].cantidad = item.cantidad;                            
                    res[0].descuento = item.descuento; 
                    } else {
                    //Si se cambia la cantidad a 0, que se elimine el producto de la lista
                    var index = store.state.orderItems.indexOf(res[0]);
                    store.state.orderItems.splice(index,1);
                    }
                } else {
                    if (item.cantidad != 0) store.state.orderItems.push(item);
                }
                if (this.$store.state.appconfig.promociones) this.checkitemPromo(item);
                this.$store.commit('setOrderItems', store.state.orderItems);
            }
        },
        checkitemPromo(item){
            var customerNo = '';
            if (this.$store.state.usuario.type == 'Cliente') 
                customerNo =  this.$store.state.usuario.custNo;
            else
                customerNo = this.$store.state.customer.no;

            var promos = item.promos;
            if (promos != undefined){                
                if (promos.length == undefined) promos = [promos];
                for (var j = 0; j < promos.length; j++){
                    if ((promos[j].itemNo != '') && (promos[j].itemPromo != '')){
                        if ((promos[j].SalesType == 'Customer') && (promos[j].salesCode != customerNo)) continue;                    
                        var a;
                        if ((Number(item.cantidad) * Number(item.qtyperuom)) >= 0)
                            a = Math.floor(Number(item.cantidad) * Number(item.qtyperuom));
                        else 
                            a = Math.ceil(Number(item.cantidad) * Number(item.qtyperuom));
                        var b = Number(promos[j].minQty);
                        if (b != 0){
                            var divInt = a / b;
                            divInt = Math.floor(divInt);
                        } else if(b == 0)   {
                            divInt = 1;
                        }
                        if (divInt != 0){
                            if (divInt >= 1){
                                var itemPromo = new Object;
                                itemPromo.isPromo = true;
                                itemPromo.no = promos[j].itemPromo;
                                itemPromo.description = promos[j].promoCode;
                                itemPromo.uom = promos[j].uom;
                                itemPromo.descuento = 100;
                                itemPromo.precio = 0;
                                itemPromo.prodPostingGroup = 0;
                                itemPromo.cantidad = Number(promos[j].PromoQty)*divInt;
                                itemPromo.fromitemNo = item.no;
                                this.setOrderItem(itemPromo,true);
                                //var cantidad = checkAvail(promos[j].promoCode,Number(promos[j].PromoQty)*divInt,Number(promos[j].PromoAvail,null));
                                //addUpdateLine(promos[j].itemPromo, promos[j].promoCode + ' - ' + promos[j].itemPromoName, cantidad, 100, 0, Number(promos[j].PromoAvail), null, null, true);	
                            }
                        }
                        if ((promos[j].SalesType == 'Customer') && (promos[j].salesCode == customerNo)) break;
                    }
                }
            }
        },
        openDialog(item){    
            if (item.uoms == null){
                this.getUoms(item,true,false,false);
            } else {
                if (item.trackingEnabled){
                    this.openDialogLote(item);
                    return;
                }            
                
                this.sameNoItems = [];      
                this.sameNoItemsBackup = [];  
                this.dialogData.code = item.no;
                this.dialogData.title = item.description;
                this.dialogData.picture = item.pictureL;
                this.dialogData.pictureLazy = item.pictureN;
    
                this.editedIndex = this.items.indexOf(item);
                this.editedItems = [];
                this.editedItems.push(Object.assign({}, item));
                this.editedItems[0].cantidad = item.cantidad;
                this.GetAvailable(item.no);
                this.dialog = true;
            }
        },
        openDialogLote(item){            
            this.sameNoItems = this.$store.state.orderItems.filter(itm=>{
                return itm.no == item.no;
            });          
            //Deep copy
            this.sameNoItemsBackup = JSON.parse(JSON.stringify(this.sameNoItems));
            //if (this.sameNoItemsBackup.length == undefined) this.sameNoItemsBackup = [this.sameNoItemsBackup];
            this.dialogData.code = item.no;
            this.dialogData.title = item.description;
            this.dialogData.picture = item.pictureL;
            this.dialogData.pictureLazy = item.pictureN;
            
            this.editedIndex = this.items.indexOf(item);
            this.editedItems = [];
            this.editedItems.push(Object.assign({}, item));
            this.editedItems[0].cantidad = 0;
            this.editedItems[0].lote = '';
            this.GetAvailable(item.no);
            this.dialog = true;
        },
        openPromoDialog(promo){
            var res = this.items.filter(item =>{
                return item.no == promo.itemNo;
            });
            if (res.length){
                this.openDialog(res[0]);
            }
        },
        lastOrder(checkCart, docType, docNo){
            var url = this.ApiBaseUrlNETCore + "sales/getLastLines/";
            var custNo = '';
            if (this.$store.state.usuario.type == 'Cliente'){
                custNo = this.$store.state.usuario.custNo;
            } else {
                custNo = this.$store.state.customer.no;
            } 
            var thisaux = this;
            if (docType == undefined) docType = "Factura Alb.";
            if (docNo == undefined) docNo = "";
            var incompleteFlag = false;
            store.commit('showGlobalLoader');
            this.axios.post(url, {custNo : custNo , docType : docType, docNo : docNo, guid : this.$store.state.usuario.userGUID },{headers: {"Content-Type": "application/json"}}) //API
            //this.axios.get(this.ApiBaseUrl + 'checkUserGUID/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID)
            .then(response => {
                //console.log(response);   
                if ((this.$store.state.orderItems.length > 0) && (response.data.length > 0) && checkCart){
                    this.$store.state.dialogLastOrder = true;
                    this.$store.state.dialogLastOrderData = {
                        docType: docType,
                        docNo:docNo
                    };
                    return;
                }
                var items = [];
                //response.data.forEach(shipmentLine => {
                var j = 0;
                response.data = response.data[0].lines;
                for (var i = 0; i < response.data.length; i++){
                    
                    var shipmentLine = response.data[i];
                    var checkurl = this.ApiBaseUrlNETCore + "items";
                    var enableCustGroups = false;
                    var cpg = '';
                    var cdg = '';
                    var appCustGroup = '';
                    if (this.$store.state.usuario.type == 'Cliente')  {      
                        enableCustGroups = this.$store.state.appconfig.enableCustGroups;
                        cpg = this.$store.state.usuario.salesGroup;
                        cdg = this.$store.state.usuario.discGroup;
                        appCustGroup = this.$store.state.usuario.appCustGroup;
                    } else {
                        cpg = this.$store.state.customer.customerPriceGroup;
                        cdg = this.$store.state.customer.customerDiscGroup;
                        appCustGroup = this.$store.state.customer.appCustGroup;
                    }
                    var epochSeconds = new Date();
                    epochSeconds = parseInt(epochSeconds.getTime() / 1000);
                    thisaux.axios.post(checkurl,
                        {
                            filter: shipmentLine.codProducto,
                            catfilter: '',
                            subCatFilter: '',
                            locfilter: '',
                            manfilter: '',
                            disponible: false,
                            top: false,
                            user: thisaux.$store.state.usuario.id,
                            userGUID: thisaux.$store.state.usuario.userGUID,
                            cust: custNo,
                            orderByGrp: false,
                            onlyAvailable: true,
                            onlyPromos: false,
                            limit: 1,
                            enableCustGroups: false,
                            epochControl: epochSeconds,
                            appCustGroup: '',
                            cpg: cpg,
                            cdg: cdg
                        },{cancelToken: undefined})
                    .then(responseCheck => {   
                        var shipmentLineLocal  = response.data[j];
                        
                        if (responseCheck.data.length == 0){
                            incompleteFlag = true;
                        } else {
                            var item = {
                                no : shipmentLineLocal.codProducto,
                                uoms : null,
                                cantidad : shipmentLineLocal.cantidad,
                                descuento : shipmentLineLocal.dto,
                                uom : shipmentLineLocal.uom,
                                uom_NAV : shipmentLineLocal.uom,
                                precio : shipmentLineLocal.price,
                                prodPostingGroup : shipmentLineLocal.vatpercent,
                                description : shipmentLineLocal.descProducto,
                                promoCode : shipmentLineLocal.promoCode,
                                item : true
                            }
                            thisaux.checkPriceAndCommitToCart(item,false,false);
                            //items.push(item);
                        }
                        if (j == response.data.length-1){
                            thisaux.getPromosRedoOrder(items);
                            if (docType == 'Abono'){
                                thisaux.$store.commit('setTipoDocumento','abono');
                            }
                            thisaux.navigate(2);
                            if (incompleteFlag){
                                thisaux.setGlobalDialog('Recuperación de pedido incompleta','No se han podido recuperar todas las lineas del pedido',false);
                            }
                        }
                        j++;
                    });
                    
                };
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
            })
            .finally(function () {  
                store.commit('hideGlobalLoader');              
            });
        },
        navigate(id){                
            var res = this.navMenu.filter(menuitem =>{ return menuitem.id == id});                        
            res[0].color = this.$store.state.colorselected;
            var res = this.navMenu.filter(menuitem =>{ return menuitem.id != id});
            for (var i = 0; i < res.length; i++){
                res[i].color = store.state.colornoselected;
            }
            switch(id){
                case 1:
                    this.$store.commit('setPromosVisible',true);
                    this.$router.push('menu');  
                    break;
                case 2:
                    this.$router.push('pedido');  
                    break;
                case 3:
                    this.$router.push('facturas');  
                    break;
            }
        },
        setGlobalDialog(title, msg, returnMenu){
            store.state.globalDialogData.titulo = title;
            store.state.globalDialogData.contenido = msg;            
            store.state.globalDialogData.returnMenu = returnMenu;
            store.state.globalDialog = true;
        },
        setEventDialog(title, msg, event){
            store.state.calEventDialogData.titulo = title;
            store.state.calEventDialogData.contenido = msg;
            store.state.calEventDialogData.event = event;
            store.state.calEventDialog = true;
        },
        setGlobalConfirmDialog(title, msg, returnMenu){
            store.state.globalConfirmDialogData.titulo = title;
            store.state.globalConfirmDialogData.contenido = msg;            
            store.state.globalConfirmDialogData.returnMenu = returnMenu;
            store.state.globalConfirmDialog = true;
        },
        setGlobalDialogPrint(title, msg, returnMenu, docNo, docType){
            store.state.globalDialogData.titulo = title;
            store.state.globalDialogData.contenido = msg;            
            store.state.globalDialogData.returnMenu = returnMenu;
            store.state.printhref = 'intent://factura/#Intent;scheme=autoventa;package=autoventa.print;S.doctype=' + docType + ';S.docno=' + docNo + ';S.browser_fallback_url=http%3A%2F%2Faliosoluciones.com;end'
            store.state.globalDialog = true;                        
        },
        setPaymentDialog(title, msg, order,total){
            store.state.dialogPaymentData.titulo = title;
            store.state.dialogPaymentData.contenido = msg;            
            store.state.dialogPaymentData.order = order; 
            store.state.dialogPaymentData.total = total; 
            store.commit("setDialogPaymentData",store.state.dialogPaymentData);
            store.state.dialogPayment = true;
        },
        getDocTitle(){
            switch(store.state.tipoDocumento){            
                case 'preventa':
                    return 'Pedido';
                case 'abono':
                    return 'Abono';  
                case 'autoventa':
                    return 'Pedido autoventa';
                default:
                    return 'Pedido';
            }
        },
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        formatDateNAV (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}${month}${year}`
        },
        formatDateSQL (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${year}-${day}-${month}`
        },
        formatDateBC (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${year}-${month}-${day}`
        },
        parseDate (date) {
          if (!date) return null
  
          const [day, month, year] = date.split('/')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        sqlDateToFormat(sqlDateStr){
            const fecha = new Date(sqlDateStr);
            
            const dia = fecha.getDate().toString().padStart(2, '0');
            const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); 
            const anio = fecha.getFullYear();

            return `${dia}/${mes}/${anio}`;
        },
        lanzaDialogCobro(documentNo){
            store.state.documentNos = [];
            if (documentNo != ''){
                store.state.documentNos.push(documentNo);
                store.state.dialogTipoCobro = true;
            } else {
                var res = store.state.facturas.filter(inv =>{
                    return inv.selected == true;
                });
                for(var i = 0; i < res.length; i++){
                    store.state.documentNos.push(res[i].DocumentNo);
                }
                store.state.dialogTipoCobro = true;
            }            
        }        
    },
    computed: {              
        navMenu:{
            get() {
                return this.$store.state.navMenu;
            },
            set(value){
                this.$store.commit('setNavMenu', value)
            }
        }
    }
}